/**
 * Typed errors for the product repository boundary.
 * Messages mirror existing server/API wording where practical.
 */
export class ProductRepositoryError extends Error {
  readonly code: string;
  readonly status: number;

  constructor(
    message: string,
    opts: { code?: string; status?: number } = {},
  ) {
    super(message);
    this.name = 'ProductRepositoryError';
    this.code = opts.code ?? 'repository_error';
    this.status = opts.status ?? 0;
  }

  static notFound(message = 'Strain not found'): ProductRepositoryError {
    return new ProductRepositoryError(message, {
      code: 'not_found',
      status: 404,
    });
  }

  static conflict(message: string): ProductRepositoryError {
    return new ProductRepositoryError(message, {
      code: 'conflict',
      status: 409,
    });
  }

  static storage(message: string): ProductRepositoryError {
    return new ProductRepositoryError(message, {
      code: 'storage_error',
      status: 500,
    });
  }
}
